<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Události
            </div>
            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
            ></v-text-field>

            <v-spacer></v-spacer>

            <v-btn fab dark small color="success" @click="addItem">
                <v-icon dark>add</v-icon>
            </v-btn>
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="items"
                :search="search"
                class="elevation-2"
                dense
        >
            <template v-slot:item.startAt="{ item }">
                <span v-if="item.startAt">
                    {{ item.startAt | moment("D.M.YYYY hh:mm") }}
                </span>
            </template>
            <template v-slot:item.endAt="{ item }">
                <span v-if="item.endAt">
                    {{ item.endAt | moment("D.M.YYYY hh:mm") }}
                </span>
            </template>
            <template v-slot:item.action="{ item }">
                <EditDeleteActions
                        :disable-delete="item.bzucoId > 0"
                        @delete="deleteItem(item.id)"
                        @edit="editItem(item)"
                />
            </template>
        </v-data-table>

        <EventDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false"
        />
    </v-card>
</template>

<script>
    import EventDialog from '../components/dialogs/EventDialog'
    import BaseListMixin from '../mixins/BaseListMixin'

    export default {
        mixins: [BaseListMixin],
        components: {
            EventDialog
        },

        data () {
            return {
                module: 'event',
                headers: [
                    { text: 'Jméno', value: 'name'},
                    { text: 'Začátek akce', value: 'startAt', width: '200px', align: 'right'},
                    { text: 'Konec akce', value: 'endAt', width: '200px', align: 'right'},
                    { text: 'Uživatel', value:'user.username', width: '200px'},
                    { text: '', value: 'action', width: '1px', sortable: false},
                ],
            }
        },
    }
</script>
